<template>
  <v-card>
    <v-card-title class="grey lighten-5 headline">
      Cadastro de perfil
    </v-card-title>
    <v-row class="pa-4" justify="space-between">
      <v-col cols="12">
        <v-form v-model="valid" ref="form">
          <v-container>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model.trim="perfil.nome"
                  label="Nome do perfil"
                  clearable
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="6" v-if="usuarioLogado.administrador">
                <v-checkbox
                  v-model="perfil.administrador"
                  :label="`Administrador`"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <div>
              <v-data-table
                :headers="headers"
                :items="permissao"
                hide-default-footer
                :items-per-page="-1"
              >
                <template v-slot:item="{ item }">
                  <tr>
                    <td>{{ item.nome }}</td>
                    <td v-for="p in item.permissoes" :key="p.permissao">
                      <v-checkbox v-model="p.permite" :disabled="!p.existe" />
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
            <v-divider></v-divider>
            <p>
              <v-btn @click="voltar" color="error" large>Voltar</v-btn>
              <v-btn
                @click="salvar"
                color="primary"
                large
                class="ml-2"
                :disabled="saving"
                >Salvar</v-btn
              >
            </p>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
    <TelaLoading :overlay="saving"></TelaLoading>
  </v-card>
</template>

<script>
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import ApiService from "@/common/services/http/api.service";
import Swal from "sweetalert2";
import SweetAlert from "@/common/services/sweetalert.service";
import TelaLoading from "@/views/components/TelaLoading.vue";
import Permissoes from "@/common/services/permissoes/permissoes.js";
import Modulo from "@/common/services/permissoes/modulos.js";
import PermissoesService from "@/common/services/permissoes/permissoes.service.js";
import { SET_LOADING } from "@/store/config.module";

export default {
  name: "perfilCadastro",
  data() {
    return {
      valid: false,
      saving: false,
      selectionType: "independent",
      cliente: {},
      usuarioLogado: {},
      perfil: {
        id: 0,
        clienteID: 0,
        nome: "",
        administrador: false,
        perfilModuloPermissoes: [],
      },
      headers: [
        { text: "", value: "" },
        { text: "Incluir", value: "" },
        { text: "Editar", value: "Editar" },
        { text: "Excluir", value: "Excluir" },
        { text: "Validar", value: "Validar" },
        { text: "Anexar", value: "Anexar" },
        { text: "Visualizar", value: "Visualizar" },
      ],
      modulo: {},
      permissoes: {},
      permissao: [],
      rules: {
        required: (v) => !!v || "Obrigatório",
      },
    };
  },
  components: {
    TelaLoading,
  },
  methods: {
    async carregarPermissoes() {
      const { data: result } = await ApiService.get(
        "perfil",
        "obter/modulo-permissoes",
        { novo: this.perfil.id == 0 }
      );

      if (result.success) {
        this.permissao = result.data;

        if (this.perfil.perfilModuloPermissoes.length != 0) {
          for (const perm of this.permissao) {
            for (const key of perm.permissoes) {
              if (key.existe) {
                if (
                  this.perfil.perfilModuloPermissoes.find(
                    (x) => x.moduloID == perm.id && x.permissaoID == key.id
                  )
                ) {
                  key.permite = true;
                }
              }
            }
          }
        }
      }
    },
    mapPerfilModuloPermissoes() {
      for (const perm of this.permissao) {
        for (const key of perm.permissoes) {
          if (key.existe) {
            let perfilModuloPermissao = this.perfil.perfilModuloPermissoes.find(
              (x) => x.moduloID == perm.id && x.permissaoID == key.id
            );
            if (key.permite) {
              if (!perfilModuloPermissao) {
                this.perfil.perfilModuloPermissoes.push({
                  moduloID: perm.id,
                  permissaoID: key.id,
                  perfilID: 0,
                });
              }
            } else {
              if (perfilModuloPermissao) {
                let index = this.perfil.perfilModuloPermissoes.indexOf(
                  perfilModuloPermissao
                );
                this.perfil.perfilModuloPermissoes.splice(index, 1);
              }
            }
          }
        }
      }
    },
    salvar() {
      let self = this;

      if (this.$refs.form.validate()) {
        this.saving = true;
        this.mapPerfilModuloPermissoes();
        if (this.perfil.administrador) this.perfil.clienteID = null;

        if (this.perfil.id === 0) {
          return new Promise((resolve) => {
            ApiService.post("perfil", this.perfil).then(({ data }) => {
              resolve(data);

              if (data.success) {
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Perfil Cadastrado com Sucesso!",
                  showConfirmButton: false,
                  timer: 1500,
                }).then(function () {
                  self.$router.push({ name: "perfil" });
                });
              } else SweetAlert.sweetAlertError(data.errors);
            });
          }).finally(() => (this.saving = false));
        } else {
          return new Promise((resolve) => {
            ApiService.put("perfil/" + this.perfil.id, this.perfil).then(
              ({ data }) => {
                resolve(data);

                if (data.success) {
                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Perfil Alterado com Sucesso!",
                    showConfirmButton: false,
                    timer: 1500,
                  }).then(function () {
                    self.$router.push({ name: "perfil" });
                  });
                } else SweetAlert.sweetAlertError(data.errors);
              }
            );
          }).finally(() => (this.saving = false));
        }
      }
    },

    async buscarperfil(id) {
      const { data: result } = await ApiService.get("perfil/" + id);

      if (result.success) this.perfil = result.data;
      else SweetAlert.sweetAlertError(result.errors);
    },

    async listaPropriedades() {
      const { data: result } = await ApiService.get(
        "grupoPropriedade/getByGrupoID/" + this.cliente.grupoPadraoperfil.id
      );

      if (result.success) {
        this.perfil.propriedades = result.data;

        this.perfil.propriedades.forEach((x) => {
          x.valor = "";
        });
      } else SweetAlert.sweetAlertError(result.errors);
    },

    voltar() {
      history.go(-1);
    },
  },
  async mounted() {
    this.$store.dispatch(SET_LOADING, true);
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "perfils" }]);
    this.permissoes = Permissoes;
    this.modulo = Modulo;

    this.cliente = JSON.parse(window.localStorage.getItem("cliente"));
    const { usuario } = JSON.parse(window.localStorage.getItem("usuario"));
    this.usuarioLogado = usuario;
    this.perfil.clienteID = this.cliente.id;

    if (this.$route.params.id !== undefined)
      await this.buscarperfil(this.$route.params.id);
    await this.carregarPermissoes();
    if (this.cliente.grupoPadraoperfil) {
      this.listaPropriedades();
      this.perfil.grupoID = this.cliente.grupoPadraoperfil.id;
    }

    this.$store.commit(SET_LOADING, false);
  },
  created() {
    let permissao = Permissoes.Incluir;

    if (this.$route.params.id !== undefined) permissao = Permissoes.Editar;

    if (!PermissoesService.verificarAcesso(Modulo.Perfil, permissao)) {
      SweetAlert.sweetAlertError([
        "Você não tem permissão para acessar essa parte do sistema",
      ]);
      this.$router.push({ name: "index" });
    }
  },
};
</script>
